import { Platform, Dimensions } from 'react-native';
import DeviceInfo from 'react-native-device-info';

const dimension = Dimensions.get('window');
const isWebPlatform = Platform.OS == 'web';
const isIos = Platform.OS == 'ios';
const isIphoneWithNotch = () => {
  if (isIos) {
    const aspectRatio = dimension.height / dimension.width;
    return dimension.height >= 812 && aspectRatio > 1.8;
  }
  return false;
};
const isIphoneX = (DeviceInfo.hasNotch() && isIos) || isIphoneWithNotch();
const isAndroid = Platform.OS == 'android';
const isWeb = isWebPlatform && dimension.width >= 991;
const isMobileWeb = isWebPlatform && dimension.width < 991;
const isNative = isIos || isAndroid;
const fullWidth = dimension.width;
const fullHeight = isWeb ? dimension.height - 100 : dimension.height;
// Edge-to-edge is enforced from API 35 upward, and at targetSdk 36 there is no opt-out.
const isAndroidEdgeToEdge = isAndroid && Number(Platform.Version) >= 35;

export {
  isWebPlatform,
  isWeb,
  isMobileWeb,
  isIos,
  isAndroid,
  isNative,
  fullWidth,
  fullHeight,
  isIphoneX,
  isAndroidEdgeToEdge,
};
